import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function CTASection() {
  return <section className="w-full py-20 px-4 md:px-8 bg-cream text-center" data-id="element-16">
      <motion.div className="max-w-3xl mx-auto" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-17">
        <h2 className="font-handwritten text-4xl md:text-5xl lg:text-6xl text-forest-green font-bold mb-6" data-id="element-18">
          Stärke den Darm deines Hundes – jeden Tag ein bisschen mehr
        </h2>

        <p className="text-xl text-gray-700 mb-10 font-serif" data-id="element-19">
          Natürliche Unterstützung für einen starken, gesunden Darm – risikofrei
          testen.
        </p>

        <div className="flex items-center justify-center gap-1.5 text-warm-brown mb-6" data-id="element-20">
          <div className="flex relative" data-id="element-21">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} className="text-warm-brown/20" data-id="element-22" />)}
            <div className="absolute top-0 left-0 overflow-hidden flex" style={{
            width: `${4.4 / 5 * 100}%`
          }} data-id="element-23">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} fill="currentColor" className="text-warm-brown shrink-0" data-id="element-24" />)}
            </div>
          </div>
          <span className="text-sm text-gray-500" data-id="element-25">
            4,4/5 · 876 Hundehalter haben es bewertet
          </span>
        </div>

        <div className="mb-8" data-id="element-26">
          <CTAButton label="Hilf auch deinem Hund — natürlich & sanft" position="bottom_cta" data-id="element-27" />
          <p className="text-[13px] text-gray-500 italic mt-3 text-center" data-id="element-28">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-29">
          <div className="flex items-center gap-1" data-id="element-30">
            <Check size={16} className="text-forest-green" data-id="element-31" />
            <span data-id="element-32">Schneller Versand</span>
          </div>
          <div className="hidden md:block text-gray-300" data-id="element-33">•</div>
          <div className="flex items-center gap-1" data-id="element-34">
            <Check size={16} className="text-forest-green" data-id="element-35" />
            <span data-id="element-36">Zufriedenheitsgarantie</span>
          </div>
          <div className="hidden md:block text-gray-300" data-id="element-37">•</div>
          <div className="flex items-center gap-1" data-id="element-38">
            <Check size={16} className="text-forest-green" data-id="element-39" />
            <span data-id="element-40">100% Natürliche Inhaltsstoffe</span>
          </div>
        </div>
      </motion.div>
    </section>;
}